import { EMPTY } from "../value";
import { PubSub } from "../value/pubsub";
// window.addEventListener('keydown', (e: KeyboardEvent) => {
//     e.preventDefault()
//     console.log('keydown', e.code, e.type)
// })
//export type DomEvents = GlobalEventHandlersEventMap
// const DOM_EVENTS: Keyed<boolean> = {
//     click: true,
//     change: true,
//     input: true,
//     focus: true,
//     blur: true
// }
export class DomNode extends PubSub {
    constructor(renderer) {
        super(renderer.events);
        //        this._subscriptions = []
        this._effects = [];
    }
    handleEvent(object) {
        this.$emit(object.type, object);
    }
    // get $ref () {
    //     return this._ref
    // }
    get $eventHandlers() {
        const result = {};
        this._handlers.forEach(h => {
            result[h.name] = (e) => {
                this.$emit(h.name, e);
            };
        });
        return result;
    }
    get $isSubscribed() {
        return this._subscriptions.length > 0;
    }
    get $value() {
        return this._el;
    }
    // set $value
    // get $uid() : string {
    //     return null
    // }
    // get $isTerminal() : boolean {
    //     return true
    // }
    // $subscribe(subscriber: Subscriber<T>|PublishFunc<T>): Subscription {
    //     // проверяем, что такая подписка уже есть
    //     for (let sub of this._subscriptions) {
    //         if (sub.subscriber == subscriber || sub.subscriber.$publish == subscriber) {
    //             return sub
    //         }
    //     }    
    //     if (typeof subscriber === 'function') {
    //         subscriber = {
    //             $publish: subscriber
    //         }
    //     }
    //     const sub: Subscription = {
    //         subscriber,
    //         observable: this
    //     }
    //     this._subscriptions.push(sub)
    //     return sub
    // }
    // $unsubscribe(subscription: Subscription|Subscriber<T>|PublishFunc<T>): void {
    //     this._subscriptions = this._subscriptions.filter(sub => sub != subscription && sub.subscriber != subscription && sub.subscriber.$publish != subscription)
    // }
    $publish(next, prev, keys) {
        this._el = next;
        this._subscriptions.forEach(sub => sub.subscriber.$publish(next));
    }
    $touch(subscriber) {
        //        console.log('dom value', this._el)
        subscriber.$publish(this._el, undefined, EMPTY);
        // if (this._el) {
        //     console.log('dom value already initialized')
        // }
        //        throw new Error("Method not implemented.");
    }
    $untouch() {
    }
}
